import { ChevronLeft, ChevronRight, Check } from 'lucide-react'

function NavigationButtons({ 
  themes, 
  currentThemeIndex, 
  scores, 
  onThemeChange, 
  onComplete, 
  onBack,
  onScrollToFirstUnanswered,
  size = 'default' // 'default' or 'compact'
}) {
  const currentTheme = themes[currentThemeIndex]
  const isLastTheme = currentThemeIndex === themes.length - 1
  const isFirstTheme = currentThemeIndex === 0
  
  // Check if current theme is completed
  const currentThemeQuestions = currentTheme.questions
  const currentThemeScores = currentThemeQuestions.map(q => scores[q.id])
  const isCurrentThemeComplete = currentThemeScores.every(score => score !== null && score !== undefined)
  
  // Calculate overall completion
  const totalQuestions = themes.reduce((total, theme) => total + theme.questions.length, 0)
  const completedQuestions = Object.values(scores).filter(score => score !== null && score !== undefined).length

  const handleNext = () => {
    // If theme is not complete and we have the scroll callback, scroll to first unanswered
    if (!isCurrentThemeComplete && !isLastTheme && onScrollToFirstUnanswered) {
      onScrollToFirstUnanswered()
      return
    }
    
    if (isLastTheme) {
      onComplete()
    } else {
      onThemeChange(currentThemeIndex + 1)
    }
  }

  const handlePrevious = () => {
    if (isFirstTheme) {
      onBack()
    } else {
      onThemeChange(currentThemeIndex - 1)
    }
  }

  const buttonSizeClasses = size === 'compact' 
    ? 'px-4 py-2 text-sm' 
    : 'px-6 py-3'

  return (
    <div className="flex justify-between items-center">
      <button
        onClick={handlePrevious}
        className={`flex items-center gap-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors ${buttonSizeClasses}`}
      >
        <ChevronLeft className="w-5 h-5" />
        {isFirstTheme ? 'Informations client' : 'Thème précédent'}
      </button>

      <button
        onClick={handleNext}
        className={`flex items-center gap-2 rounded-lg transition-all duration-300 ${buttonSizeClasses} ${
          isLastTheme
            ? completedQuestions === totalQuestions
              ? 'bg-green-600 text-white hover:bg-green-700 shadow-lg'
              : 'bg-gray-300 text-gray-500 hover:bg-gray-400 cursor-pointer'
            : isCurrentThemeComplete
            ? 'bg-cedec-blue text-white hover:bg-blue-700 shadow-lg'
            : 'bg-gray-300 text-gray-500 hover:bg-gray-400 cursor-pointer'
        }`}
      >
        {isLastTheme ? (
          <>
            Terminer l'évaluation
            <Check className="w-5 h-5" />
          </>
        ) : (
          <>
            Thème suivant
            <ChevronRight className="w-5 h-5" />
          </>
        )}
      </button>
    </div>
  )
}

export default NavigationButtons
